import React from 'react'
import {Link} from 'react-router-dom'
import '../../stylesheets/MenuSS.css'
import logo from '../../images/ak_no_back.png'
function Menu() {
  return (
    <menu>
      <img src={logo} alt='logo' id='logo'></img>
      <ul>
        <li><Link to={{pathname:"/"}} className='link'>Home</Link></li>
        <li><Link to={{pathname:"/articles"}} className='link'>Articles</Link></li>
        <li><Link to={{pathname:"/extra"}} className='link'>Extra</Link></li>
      </ul>
    </menu>
  )
}

export default Menu;